import { Button, ButtonProps } from '@chakra-ui/react';

const drawerActionStyles: ButtonProps = {
    backgroundColor: 'white',
    fontSize: 'sm',
    color: 'grey',
    _hover: { color: '#f0706e' },
    _focus: { backgroundColor: 'white' },
    _active: { backgroundColor: 'white' },
};

type DrawerActionButtonProps = ButtonProps;

export function DrawerActionButton(props: DrawerActionButtonProps) {
    return <Button {...drawerActionStyles} {...props} />;
}
